export const getUnacknowledgedNotifications = (state) => {
    return state.unacknowledgedNotifications
}

export const getNotificationsCount = (state) => {
    return state.notificationsCount
}
